import axiosClient from 'apis/axios-client';
import { AxiosResponse } from 'axios';

const DASHBOARD_DATA_URL = '/AdminDashboard/Dashboard';
const MONTHLY_LOAD_SUMMARY_URL = '/AdminDashboard/GetMonthlyLoadSummary/';
const LOAD_DETAILS_URL = '/AdminDashboard/GetLoadDetails';
const ANSWERED_DETAILS_URL = '/AdminDashboard/GetAnsweredDetails';


export const getDashboardData = async (): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosClient.get(DASHBOARD_DATA_URL);
    return response; // Return only the data from the response
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error fetching dashboard data:', error.message);
    } else {
      console.error('Unknown error fetching dashboard data');
    }
    throw error;
  }
};


export const getMonthlyLoadSummary = async (year: number): Promise<any> => {
    try {
      const response: AxiosResponse<any> = await axiosClient.get(`${MONTHLY_LOAD_SUMMARY_URL}?year=${year}`);
      return response.data; // Return only the data from the response
    } catch (error) {
      if (error instanceof Error) {
        console.error('Error fetching monthly load summary:', error.message);
      } else {
        console.error('Unknown error fetching monthly load summary');
      }
      throw error;
    }
  };

  export const getLoadDetails = async (
    page: number, 
    pageSize: number,
    search?: string,
    fromDate?: string,
    toDate?: string
  ): Promise<any> => {
    try {
      let url = `${LOAD_DETAILS_URL}?Page=${page}&PageSize=${pageSize}`;
      if (search) {
        url += `&Search=${encodeURIComponent(search)}`;
      }
      if (fromDate) {
        url += `&FromDate=${fromDate}`;
      }
      if (toDate) {
        url += `&ToDate=${toDate}`;
      }
      const response: AxiosResponse<any> = await axiosClient.get(url);
      return response; // Return only the data from the response
    } catch (error) {
      if (error instanceof Error) {
        console.error('Error fetching load details:', error.message);
      } else {
        console.error('Unknown error fetching load details');
      }
      throw error;
    }
  };

  export const getAnsweredDetails = async (
    page: number, 
    pageSize: number,
    search?: string,
    fromDate?: string,
    toDate?: string
  ): Promise<any> => {
    try {
      let url = `${ANSWERED_DETAILS_URL}?Page=${page}&PageSize=${pageSize}`;
      if (search) {
        url += `&Search=${encodeURIComponent(search)}`;
      }
      if (fromDate) {
        url += `&FromDate=${fromDate}`;
      }
      if (toDate) {
        url += `&ToDate=${toDate}`;
      }
      const response: AxiosResponse<any> = await axiosClient.get(url);
      return response; // Return only the data from the response
    } catch (error) {
      if (error instanceof Error) {
        console.error('Error fetching answered details:', error.message);
      } else {
        console.error('Unknown error fetching answered details');
      }
      throw error;
    }
  };
  
